"use strict";
import Account from "../api/account";
import Api from "../api/api";
import CarrierTypeAhead from "./carrier_typeahead";
import DisablingButton from "../components/disabling_button";
import DocumentBrowser from "./react_document_browser";
import documentFormatter from "../formatters/documents";
import "./documents_service";
import generalFormatter from "../formatters/general";
import Paginator from "../util/paginator";
import reactUtils from "../react_utils";
import WaitingSpinner from "../components/waiting_spinner";
import {
  GroupedDocumentBrowserModel,
  GroupIDGroupCreator
} from "./grouped_document_browser_model";
var bem = reactUtils.makeBem("email-merger");
export default React.createClass({
  propTypes: {
    carrier: React.PropTypes.object.isRequired,
    emailId: React.PropTypes.number.isRequired,
    location: React.PropTypes.object.isRequired,
    onCancel: React.PropTypes.func.isRequired
  },
  getInitialState: function() {
    return {
      emailMessages: [],
      loadingEmails: false,
      emailsForMergingIds: [],
      selectedCarrier: this.props.carrier
    };
  },
  componentDidMount: function() {
    this.loadEmails();
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.state.loadingEmails || this.state.mergingEmails }, /* @__PURE__ */ React.createElement("div", { className: "modal__large-container" }, this.content()));
  },
  loadEmails: function() {
    this.setState({ loadingEmails: true });
    Api.Email.index({ carrierId: this.state.selectedCarrier.id }).then((results) => {
      this.setState({
        emailMessages: this.emailsWithoutCurrent(results.email_messages),
        loadingEmails: false
      });
    });
  },
  content: function() {
    if (this.state.viewDocuments) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-indexer__left-side-document-browser" }, /* @__PURE__ */ React.createElement(
        DocumentBrowser,
        {
          location: this.props.location,
          allowsEditing: false,
          closeBrowser: this.closeDocumentBrowser,
          model: this.state.modelForBrowser,
          collapseSingleGroup: true,
          allowsEditingPodStatus: false,
          canEditDocumentType: false
        }
      ));
    } else {
      return /* @__PURE__ */ React.createElement("div", null, this.mergeHeader(), this.mergeText(), this.actionRow(), this.emailsHeader(), this.mapEmails(), this.pagination(), this.cancelButton());
    }
  },
  actionRow: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__action-row") }, this.mergeButton(), this.carrierSelector());
  },
  pagination: function() {
    return /* @__PURE__ */ React.createElement(
      Paginator,
      {
        location: this.props.location,
        numberOfPages: this.numberOfPages()
      }
    );
  },
  cancelButton: function() {
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--caution",
        onClick: this.props.onCancel
      },
      "Cancel"
    );
  },
  currentPage: function() {
    return _.min([
      parseInt(this.props.location.query["page"] || "1"),
      this.numberOfPages()
    ]);
  },
  startOffset: function() {
    return this.perPage() * (this.currentPage() - 1);
  },
  perPage: function() {
    return 5;
  },
  numberOfPages: function() {
    return Math.ceil(parseFloat(this.state.emailMessages.length) / this.perPage());
  },
  documentTypesForEmail(email) {
    return _.chain(email.document_batch.documents).map((document) => {
      if (_.contains(
        [
          "invoice",
          "rateConfirmation",
          "billOfLading"
        ],
        document.type
      )) {
        return documentFormatter.title(document);
      } else {
        return "Other";
      }
    }).groupBy(_.identity).pairs().map(([t, ts]) => `${t} (${ts.length})`).value();
  },
  carrierSelector: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__action-item") + " " + bem("__typeahead-container") }, /* @__PURE__ */ React.createElement("span", { className: bem("__carrier-filter-label") }, Account.carrierTerm().toUpperCase(), " FILTER:"), /* @__PURE__ */ React.createElement("div", { className: bem("__carrier-typeahead") }, /* @__PURE__ */ React.createElement(
      CarrierTypeAhead,
      {
        onSelectCarrier: this.carrierSelected,
        onClearCarrier: this.carrierCleared,
        onFocus: _.partial(this.selectionChange, 0),
        showTextArea: true,
        includeUnknown: true,
        carrier: this.state.selectedCarrier
      }
    )), /* @__PURE__ */ React.createElement(
      "button",
      {
        onClick: this.resetToEmailCarrier,
        className: "dashboard__clear-carrier-filter-button inactive-gradient"
      },
      "Reset"
    ));
  },
  resetToEmailCarrier: function() {
    this.setState({ selectedCarrier: this.props.carrier }, this.loadEmails);
  },
  carrierSelected: function(carrier) {
    this.setState({ selectedCarrier: carrier }, this.loadEmails);
  },
  emailsWithoutCurrent: function(emails) {
    return emails.filter((email) => email.id != this.props.emailId);
  },
  mergeHeader: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__header") }, "Merge Emails");
  },
  mergeText: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box--highlight" }, "After merging you will be redirected to the dashboard where the merged email will appear in the New queue. You will be able to process the merged email after the merging processes complete. This may take a few minutes.");
  },
  mergeButton: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__action-item") }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabled: !this.emailsSelected(),
        onClick: this.mergeEmails,
        disabledText: "Select Email(s) for Merge",
        className: "button--progress"
      },
      "Merge Selected Emails"
    ));
  },
  emailsSelected: function() {
    return this.state.emailsForMergingIds.length > 0;
  },
  mergeEmails: function() {
    this.setState({ mergingEmails: true });
    Api.Email.merge(this.idsForMerge()).then((results) => {
      this.setState({ mergingEmails: false });
    }).then(this.props.mergeComplete);
  },
  idsForMerge: function() {
    return [this.props.emailId].concat(this.state.emailsForMergingIds);
  },
  emailsForMergingIdsChanged: function(e) {
    let ids;
    let existing = this.state.emailsForMergingIds;
    const newId = parseInt(e.target.value);
    if (_.contains(existing, newId)) {
      const index = existing.indexOf(newId);
      existing.splice(index, 1);
      ids = existing;
    } else {
      ids = existing.concat(newId);
    }
    this.setState({ emailsForMergingIds: ids });
  },
  mapEmails() {
    const messages = this.state.emailMessages.slice(
      this.startOffset(),
      this.startOffset() + this.perPage()
    );
    if (messages.length > 0) {
      return _.map(messages, (emailMessage) => {
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            key: "email_message__" + emailMessage.id,
            className: "row factor-invoice__search-items-container"
          },
          /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 column factor_invoice__search-item" }, /* @__PURE__ */ React.createElement(
            "input",
            {
              type: "checkbox",
              value: emailMessage.id,
              checked: _.contains(
                this.state.emailsForMergingIds,
                emailMessage.id
              ),
              onChange: this.emailsForMergingIdsChanged
            }
          )), /* @__PURE__ */ React.createElement("div", { className: "small-3 column factor_invoice__search-item" }, /* @__PURE__ */ React.createElement("div", null, emailMessage.subject), /* @__PURE__ */ React.createElement("div", null, emailMessage.sender_address)), /* @__PURE__ */ React.createElement("div", { className: "small-2 column factor_invoice__search-item" }, generalFormatter.superShortDate(emailMessage.created_at) + " " + generalFormatter.superShortTime(emailMessage.created_at)), /* @__PURE__ */ React.createElement("div", { className: "small-2 column factor_invoice__search-item" }, emailMessage.carrier && emailMessage.carrier.name || "Unknown " + Account.carrierTerm()), /* @__PURE__ */ React.createElement("div", { className: "small-2 column factor_invoice__search-item " }, /* @__PURE__ */ React.createElement(
            "div",
            {
              className: "factor-invoice__documents-icon",
              onClick: _.partial(
                this.openDocumentBrowser,
                emailMessage.document_batch
              )
            },
            /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__documents-count" }, this.documentTypesForEmail(emailMessage).join(", "))
          )))
        );
      });
    } else {
      return /* @__PURE__ */ React.createElement("div", null, "There are no email messages for that ", Account.carrierTermLower(), ".");
    }
  },
  closeDocumentBrowser: function() {
    this.setState({ viewDocuments: false });
  },
  openDocumentBrowser: function(documentBatch) {
    var model = this.modelForBrowser(documentBatch);
    this.setState({ modelForBrowser: model, viewDocuments: true });
  },
  modelForBrowser: function(documentBatch) {
    return new GroupedDocumentBrowserModel(
      new GroupIDGroupCreator(
        documentBatch.documents,
        documentBatch.document_groups
      ),
      () => {
        return false;
      },
      null
    );
  },
  emailsHeader: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "row factor-invoice__search-headers-row" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 column" }, "\xA0"), /* @__PURE__ */ React.createElement("div", { className: "small-3 column factor-invoice__search-header" }, "SENDER INFORMATION"), /* @__PURE__ */ React.createElement("div", { className: "small-2 column factor-invoice__search-header" }, "DATE"), /* @__PURE__ */ React.createElement("div", { className: "small-2 column factor-invoice__search-header" }, Account.carrierTerm().toUpperCase()), /* @__PURE__ */ React.createElement("div", { className: "small-2 column factor-invoice__search-header" }, "DOCUMENTS"));
  }
});
